module.exports = __webpack_public_path__ + "static/media/loading.97f374ff.gif";